module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edit_wrap"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "pl20 pr20"
  }, [_c('div', {
    staticClass: "add_brand mt20"
  }, [_c('div', {
    staticClass: "add_name mt20"
  }, [_c('div', {
    staticClass: "ml26"
  }, [_c('span', {
    staticClass: "main_word mr4"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', {
    staticClass: "vm form_color mr8"
  }, [_vm._v("已有品牌：")]), _vm._v(" "), _c('el-select', {
    staticClass: "vm",
    attrs: {
      "placeholder": "请选择品牌"
    },
    on: {
      "change": function($event) {
        _vm.selectBrand()
      }
    },
    model: {
      value: (_vm.brandInfo.brandId),
      callback: function($$v) {
        _vm.$set(_vm.brandInfo, "brandId", $$v)
      },
      expression: "brandInfo.brandId"
    }
  }, _vm._l((_vm.brands), function(val) {
    return _c('el-option', {
      key: val.brandId,
      attrs: {
        "label": val.brandName,
        "value": val.brandId
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "c_name mt20"
  }, [_c('span', {
    staticClass: "main_word mr4"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', {
    staticClass: "form_color mr8"
  }, [_vm._v("品牌中文名称：")]), _vm._v(" "), (!_vm.alSelect) ? _c('span', {
    staticClass: "main_word f12"
  }, [_vm._v("根据您选择的大V店已有品牌，系统自动填充中文名称")]) : _c('span', {
    staticClass: "ml8"
  }, [_vm._v(_vm._s(_vm.brandInfo.brandName))])]), _vm._v(" "), _c('div', {
    staticClass: "e_name mt20"
  }, [_c('span', {
    staticClass: "main_word mr4"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', {
    staticClass: "form_color mr8"
  }, [_vm._v("品牌英文名称：")]), _vm._v(" "), (!_vm.alSelect) ? _c('span', {
    staticClass: "main_word f12"
  }, [_vm._v("根据您选择的大V店已有品牌，系统自动填充英文名称")]) : _c('span', {
    staticClass: "ml8"
  }, [_vm._v(_vm._s(_vm.brandInfo.brandEnname))])])])]), _vm._v(" "), _c('div', {
    staticClass: "mt20"
  }, [_c('el-form', {
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.brandInfo,
      "label-width": "129px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "品牌合作品类："
    }
  }, [_c('el-select', {
    staticClass: "vtb",
    attrs: {
      "placeholder": "请选择一级类目"
    },
    on: {
      "change": _vm.getTowList
    },
    model: {
      value: (_vm.cata.first),
      callback: function($$v) {
        _vm.$set(_vm.cata, "first", $$v)
      },
      expression: "cata.first"
    }
  }, _vm._l((_vm.oneList), function(val) {
    return _c('el-option', {
      key: val.id,
      attrs: {
        "label": val.name,
        "value": val.id
      }
    })
  })), _vm._v(" "), _c('el-select', {
    staticClass: "vtb",
    attrs: {
      "placeholder": "请选择二级类目"
    },
    on: {
      "change": _vm.getThreeList
    },
    model: {
      value: (_vm.cata.second),
      callback: function($$v) {
        _vm.$set(_vm.cata, "second", $$v)
      },
      expression: "cata.second"
    }
  }, _vm._l((_vm.twoList), function(val) {
    return _c('el-option', {
      key: val.id,
      attrs: {
        "label": val.name,
        "value": val.id
      }
    })
  })), _vm._v(" "), _c('el-select', {
    staticClass: "vtb",
    attrs: {
      "placeholder": "请选择三级类目"
    },
    on: {
      "change": _vm.selectInfo
    },
    model: {
      value: (_vm.cata.categoryId),
      callback: function($$v) {
        _vm.$set(_vm.cata, "categoryId", $$v)
      },
      expression: "cata.categoryId"
    }
  }, _vm._l((_vm.threeList), function(val) {
    return _c('el-option', {
      key: val.id,
      attrs: {
        "label": val.name,
        "value": val.id
      }
    })
  })), _vm._v(" "), _c('el-button', {
    staticClass: "vtb",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addDomain
    }
  }, [_vm._v("添加合作类目")])], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%",
      "margin": "0 auto",
      "margin-bottom": "22px"
    },
    attrs: {
      "data": _vm.brandInfo.categories,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "主营品类",
      "width": "200",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.category.grandName) + "--")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.category.parentName) + "--")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.category.childrenName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否提供发票",
      "width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-radio-group', {
          attrs: {
            "disabled": _vm.provideInvoice != null
          },
          on: {
            "change": function($event) {
              _vm.selProvideInvoice(scope.row, scope.store)
            }
          },
          model: {
            value: (scope.row.provideInvoice),
            callback: function($$v) {
              _vm.$set(scope.row, "provideInvoice", $$v)
            },
            expression: "scope.row.provideInvoice"
          }
        }, [_c('el-radio', {
          attrs: {
            "label": 0
          }
        }, [_c('span', {
          staticClass: "f14 f666"
        }, [_vm._v("否")])]), _vm._v(" "), _c('el-radio', {
          attrs: {
            "label": 1
          }
        }, [_c('span', {
          staticClass: "f14 f666"
        }, [_vm._v("是")])])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "发票类型",
      "align": "center",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          attrs: {
            "disabled": scope.row.provideInvoice == 0,
            "placeholder": "请选择发票类型"
          },
          on: {
            "change": function($event) {
              _vm.selInvoiceType(scope.row)
            }
          },
          model: {
            value: (scope.row.invoiceType),
            callback: function($$v) {
              _vm.$set(scope.row, "invoiceType", $$v)
            },
            expression: "scope.row.invoiceType"
          }
        }, [(_vm.registeredCountry == 1) ? _c('el-option', {
          attrs: {
            "label": "增值税普通发票",
            "value": 1
          }
        }) : _vm._e(), _vm._v(" "), (_vm.registeredCountry == 1 && _vm.taxpayerType == 1) ? _c('el-option', {
          attrs: {
            "label": "增值税专用发票",
            "value": 2
          }
        }) : _vm._e(), _vm._v(" "), (_vm.registeredCountry == 1 && _vm.taxpayerType == 2) ? _c('el-option', {
          attrs: {
            "label": "增值税专用发票（需去税务局代开）",
            "value": 2
          }
        }) : _vm._e(), _vm._v(" "), (_vm.registeredCountry != 1) ? _c('el-option', {
          attrs: {
            "label": "形式发票",
            "value": 3
          }
        }) : _vm._e()], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "税率",
      "align": "center",
      "min-width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return scope.row.ratesStr != null && scope.row.ratesStr != undefined ? [(_vm.taxpayerType == 1 && scope.row.invoiceType == 1) ? _c('el-radio-group', {
          model: {
            value: (scope.row.ratesStr),
            callback: function($$v) {
              _vm.$set(scope.row, "ratesStr", $$v)
            },
            expression: "scope.row.ratesStr"
          }
        }, [_c('el-radio', {
          staticStyle: {
            "margin-left": "0px"
          },
          attrs: {
            "disabled": scope.row.provideInvoice == 0,
            "label": "0"
          }
        }, [_vm._v("0%")]), _vm._v(" "), _c('el-radio', {
          staticStyle: {
            "margin-left": "0px"
          },
          attrs: {
            "disabled": scope.row.provideInvoice == 0,
            "label": "6"
          }
        }, [_vm._v("6%")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-radio', {
          staticStyle: {
            "margin-left": "0px"
          },
          attrs: {
            "disabled": scope.row.provideInvoice == 0,
            "label": "9"
          }
        }, [_vm._v("9%")]), _vm._v(" "), _c('el-radio', {
          staticStyle: {
            "margin-left": "0px"
          },
          attrs: {
            "disabled": scope.row.provideInvoice == 0,
            "label": "10"
          }
        }, [_vm._v("10%")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-radio', {
          staticStyle: {
            "margin-left": "0px"
          },
          attrs: {
            "disabled": scope.row.provideInvoice == 0,
            "label": "13"
          }
        }, [_vm._v("13%")]), _vm._v(" "), _c('el-radio', {
          staticStyle: {
            "margin-left": "0px"
          },
          attrs: {
            "disabled": scope.row.provideInvoice == 0,
            "label": "16"
          }
        }, [_vm._v("16%")])], 1) : _vm._e(), _vm._v(" "), (_vm.taxpayerType == 1 && scope.row.invoiceType == 2) ? _c('el-radio-group', {
          model: {
            value: (scope.row.ratesStr),
            callback: function($$v) {
              _vm.$set(scope.row, "ratesStr", $$v)
            },
            expression: "scope.row.ratesStr"
          }
        }, [_c('el-radio', {
          staticStyle: {
            "margin-left": "0px"
          },
          attrs: {
            "disabled": scope.row.provideInvoice == 0,
            "label": "6"
          }
        }, [_vm._v("6%")]), _vm._v(" "), _c('el-radio', {
          staticStyle: {
            "margin-left": "0px"
          },
          attrs: {
            "disabled": scope.row.provideInvoice == 0,
            "label": "9"
          }
        }, [_vm._v("9%")]), _vm._v(" "), _c('el-radio', {
          staticStyle: {
            "margin-left": "0px"
          },
          attrs: {
            "disabled": scope.row.provideInvoice == 0,
            "label": "10"
          }
        }, [_vm._v("10%")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-radio', {
          staticStyle: {
            "margin-left": "0px"
          },
          attrs: {
            "disabled": scope.row.provideInvoice == 0,
            "label": "13"
          }
        }, [_vm._v("13%")]), _vm._v(" "), _c('el-radio', {
          staticStyle: {
            "margin-left": "0px"
          },
          attrs: {
            "disabled": scope.row.provideInvoice == 0,
            "label": "16"
          }
        }, [_vm._v("16%")])], 1) : _vm._e(), _vm._v(" "), (_vm.taxpayerType == 2) ? _c('el-radio-group', {
          model: {
            value: (scope.row.ratesStr),
            callback: function($$v) {
              _vm.$set(scope.row, "ratesStr", $$v)
            },
            expression: "scope.row.ratesStr"
          }
        }, [_c('el-radio', {
          attrs: {
            "disabled": scope.row.provideInvoice == 0,
            "label": "0"
          }
        }, [_vm._v("0%")]), _vm._v(" "), _c('el-radio', {
          attrs: {
            "disabled": scope.row.provideInvoice == 0,
            "label": "3"
          }
        }, [_vm._v("3%")])], 1) : _vm._e()] : undefined
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "200",
      "label": "品类经营特许资质电子版",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-upload', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.franchiseQualification),
            expression: "scope.row.franchiseQualification"
          }],
          staticClass: "hide_up",
          staticStyle: {
            "max-height": "149px",
            "overflow": "hidden"
          },
          attrs: {
            "action": "/suppliers/uploadImageData?biz=0",
            "name": "pic",
            "data": {
              data: scope.$index
            },
            "list-type": "picture-card",
            "file-list": scope.row.franchiseQualificationFile,
            "on-preview": _vm.handlePictureCardPreview,
            "on-remove": _vm.handleRemove,
            "on-success": _vm.handleUpload,
            "before-upload": _vm.beforeUpload
          }
        }, [_c('i', {
          staticClass: "el-icon-plus"
        })]), _vm._v(" "), (!scope.row.franchiseQualification == 1) ? _c('span', [_vm._v("不需要")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "76",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              _vm.deleteDomain(scope.$index, _vm.brandInfo.categories)
            }
          }
        }, [_vm._v("删除\n                            ")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mb20",
    attrs: {
      "align": "center"
    }
  }, [_c('el-button', {
    staticClass: "mr10",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.cancel()
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.submit()
      }
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible,
      "size": "small"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "add_top"
  }, [_c('div', {
    staticClass: "add_tab active_tab"
  }, [_vm._v("添加品类")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ae32dfe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/info_manage/brand_supple_agree/add_category.vue
// module id = 514
// module chunks = 0